<app-header></app-header>

<mat-card class="wide-form-card center f-nunito">
  <mat-card-header>
    <mat-card-title style="text-align: center">
      {{"UPLOADS.PAYMENT_SUCCESS.TITLE" | translate }}
    </mat-card-title>
  </mat-card-header>
      <mat-card-content style="text-align: center;">
        {{"UPLOADS.PAYMENT_SUCCESS.TEXT" | translate}}

        <br /><br /><br />

        <div [hidden]="!loading">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          <br /><br />
          {{"UPLOADS.PAYMENT_SUCCESS.WAIT_FOR_PAYMENT" | translate}}
        </div>

      </mat-card-content>
    </mat-card>
